import { Announcement } from '../types/Announcement';

export const announcements: Announcement[] = [
  {
    id: 'update-1',
    title: 'App Update v1.1',
    description: 'New seasonal badges and performance improvements.',
    date: new Date().toISOString(),
  },
];
